import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _findIndex from "lodash/findIndex";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { unreachableWithReturn } from '../unreachable';
export const getCampusTriggerByModelTag = modelTag => {
  switch (modelTag) {
    case 'learn-explain-error-prod':
    case 'learn-explain-error-staging':
    case 'learn-explain-error-candidate':
      return 'campusUser';
    case 'learn-hint-prod':
    case 'learn-hint-staging':
    case 'learn-hint-candidate':
      return 'campusUserHint';
    default:
      return unreachableWithReturn(modelTag, undefined);
  }
};
export const getModelTag = (isProductionEnvironment, messageType, isExperiment) => {
  const environment = isProductionEnvironment ? 'prod' : 'staging';
  const tagPrefix = messageType === 'ASSISTANT' ? 'learn-explain-error' : 'learn-hint';
  return isExperiment && messageType === 'ASSISTANT' ? "".concat(tagPrefix, "-candidate") : "".concat(tagPrefix, "-").concat(environment);
};
export const appendClassSuffix = (className, feedbackMessageType) => {
  return "".concat(className, "--").concat(feedbackMessageType.toLocaleLowerCase());
};
export const calculateMaxTabs = (containerWidth, isHintAndSolutionVisible) => {
  const baseTabListPadding = 16 * 2;
  const marginBetweenTabs = 6;
  const tabWidth = 36;
  const tabFullWidth = marginBetweenTabs + tabWidth;
  // solution width + 2 digit xp penalty
  const hintAndSolutionWidth = isHintAndSolutionVisible ? 222 : 0;
  return Math.floor((containerWidth + marginBetweenTabs - (baseTabListPadding + hintAndSolutionWidth)) / tabFullWidth);
};
export const getVisibleFeedbackMessages = (feedbackMessages, maxTabs) => {
  const hintIndex = _findIndex(feedbackMessages, {
    messageType: 'HINT'
  });
  const solutionIndex = _findIndex(feedbackMessages, {
    messageType: 'SOLUTION'
  });
  const activeFeedbackIndex = _findIndex(feedbackMessages, 'isActive');
  const deduplicate = arr => Array.from(new Set(arr));
  const pinnableTabIndices = deduplicate([hintIndex, solutionIndex, activeFeedbackIndex]);
  const pinnedTabIndices = pinnableTabIndices.filter(pinnableTabIndex => pinnableTabIndex > -1).slice(0, maxTabs);
  const nbFeedbackMessages = feedbackMessages.length;
  return feedbackMessages.map((feedbackMessage, index) => _objectSpread(_objectSpread({}, feedbackMessage), {}, {
    tabIndex: index
  })).reduce((acc, feedbackMessage) => {
    const positionFromEnd = nbFeedbackMessages - feedbackMessage.tabIndex;
    // acc is used because pinnedTabIndices and the last ${maxTabs} tabs
    // can intersect in different ways
    const remainingSlots = maxTabs - acc.length;
    if (pinnedTabIndices.includes(feedbackMessage.tabIndex) ||
    // there can be more slots than tabs
    positionFromEnd <= remainingSlots) {
      return acc.concat(feedbackMessage);
    }
    return acc;
  }, []);
};